var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.332,
    height: 19.809,
    viewBox: "0 0 21.332 19.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75000",
    "data-name": "Group 75000",
    transform: "translate(-16656 -15262.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M266.576,213.024l-4.286-10.38a1.048,1.048,0,0,0-1.937,0l-4.286,10.38a1.048,1.048,0,1,0,1.937.8l.873-2.114h4.889l.873,2.114a1.047,1.047,0,1,0,1.936-.8Zm-6.833-3.409,1.579-3.826,1.579,3.826Z",
    transform: "translate(16410.676 15067.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M43.23,62.043A1.048,1.048,0,0,0,43,60.581a13.621,13.621,0,0,1-1.738-1.654A24.573,24.573,0,0,0,44.653,52.1H46.19a1.048,1.048,0,0,0,0-2.1H40.666v-.952a1.048,1.048,0,1,0-2.1,0V50H33.048a1.048,1.048,0,0,0,0,2.1H42.44a22.731,22.731,0,0,1-2.561,5.16,17.982,17.982,0,0,1-2.056-3.279,1.048,1.048,0,1,0-1.932.81,20,20,0,0,0,2.517,4l.13.167a19.477,19.477,0,0,1-4.469,3.845,1.048,1.048,0,1,0,1,1.839,20.514,20.514,0,0,0,4.839-4.076,14.371,14.371,0,0,0,1.854,1.719,1.048,1.048,0,0,0,1.464-.233Z",
    transform: "translate(16624 15214.596)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.e131f4a6ae4119cffc8c8edf091d21ba.svg";
export { ForwardRef as ReactComponent };